import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';

import * as actions from '../overlayFull/overlayActions';
import ADDRESS_AND_CONTACT from '../../../utils/addressAndContact';
import MapHolder from '../../../../components/map-elements/map-holder';

import './stock.less';

class StockStatus extends Component {
  handleClick() {
    const payload = {
      show: false,
      content: null,
    };
    this.props.POPULATE_CONTENT(payload);
  }

  stopPropagation(e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }

  formatSize(size) {
    const splitSize = size.split('/');
    if (size.indexOf('/') > -1) {
      return splitSize[0];
    }
    return size;
  }

  render() {
    const {
      fs_sizes, shouldGoogleMapsLoad, language, flagshipPhone, openingHours,
    } = this.props;
    const addressAndContact = ADDRESS_AND_CONTACT[language];
    return (
      <div className="fsTab">
        <div className="stockContentInfo">
          <div className="stockInfo separator">
            <div className="tab-title">
              {t`Sizes in stock in the store:`}
            </div>
            <div className="text fs-sizes">
              {fs_sizes.length > 0 ? (
                fs_sizes.map((el, i) => {
                  const size = this.formatSize(el.name);
                  const last = fs_sizes.length - 1;
                  return (
                    <span key={el.name}>{`${size}${i === last ? '' : ', '}`}</span>
                  );
                })
              ) : (
                <div className="text">{t`No available sizes`}</div>
              )}
            </div>
            {fs_sizes.length > 0 && (
              <div className="fs-disclaimer text b-br">
                {t`Please notice that it is not possible to reserve products`}
              </div>
            )}
          </div>
          <div className="fs-tab-bottom">
            <div className="fs-bottom-half right">
              <div className="b-br text">
                <div className="tab-title">{t`Unisport Flagship Store`}</div>
                {openingHours[0].hours ? openingHours.map((el) => {
                  return (<div key={el.days}>{`${el.days}: ${el.hours}`}</div>);
                }) : ''}
              </div>
              <div className="b-br">
                <div
                  className="text phone"
                  onClick={this.stopPropagation}
                  role="presentation"
                >
                  {t`Phone:`}
                  {' '}
                  <a href={`tel:${flagshipPhone || addressAndContact.phone}`} className="green">
                    {flagshipPhone || addressAndContact.phone}
                  </a>
                </div>
                <div
                  className="text email"
                  onClick={this.stopPropagation}
                  role="presentation"
                >
                  {t`Email:`}
                  {' '}
                  <a href={`mailto:${addressAndContact.email}`} className="green">
                    {addressAndContact.email}
                  </a>
                </div>
              </div>
              <div className="b-br no-margin">
                <div className="text address">{addressAndContact.address}</div>
                <div className="text address">{`${addressAndContact.postalcode} ${addressAndContact.city}`}</div>
                <div className="text address">{addressAndContact.country}</div>
              </div>
            </div>
            <div
              className="map-holder fs-bottom-half left"
              onClick={this.stopPropagation}
              onMouseEnter={() => { if (!shouldGoogleMapsLoad) this.props.shouldGoogleMapLoad(); }}
              role="presentation"
            >
              <MapHolder
                shouldGoogleMapsLoad={shouldGoogleMapsLoad}
                language={this.props.language}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ app, tabs, general }) => {
  return {
    fs_sizes: app.data.fs_sizes,
    shouldGoogleMapsLoad: tabs.shouldGoogleMapsLoad,
    language: general.language,
    openingHours: app.data.opening_hours,
    flagshipPhone: app.data.flagship_phone,
  };
};

const mapDispatchToProps = dispatch => ({
  ...actions,
  shouldGoogleMapLoad: () => dispatch({ type: 'SHOULD_GOOGLE_MAPS_LOAD' }),
});


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StockStatus);
